import type { ApiEmbedSearchWidgetId } from 'api/types/ApiTypedId';
import { embedSearchWidgetViewVolopRoute } from 'modules/embedSearchWidget/routing/embedSearchWidget.routes';
import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';

type Args = {
  result: SearchAlgoliaHit;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | undefined;
};

export function searchContextHeaderGetUrl({
  result,
  embedSearchWidgetId,
}: Args) {
  if (embedSearchWidgetId) {
    return embedSearchWidgetViewVolopRoute.with({
      lang: CURRENT_LOCALE(),
      embedSearchWidgetId,
      volopId: result.objectID,
    });
  }

  if (result.type === 'IMPORTED') {
    const source = result.source
      ? result.source.replace(/_/g, '-').toLowerCase()
      : '';

    return `/${CURRENT_LOCALE()}/imported-action-opps/${source}/${result.objectID.replace(
      `${result.source}_`,
      '',
    )}`;
  }

  if (typeof result.url === 'string') return result.url;

  return result.url[CURRENT_LOCALE()];
}
